import type { ApiDraw, ApiEvent, ApiTier } from '../../shared/types';
import { get, patch, post, remove } from '../../shared/api/http';

export interface EventPool {
  rule: 'weekly' | 'monthly';
  cutoff: string;
  cartelas: { id: string; number: string; playerId: string; playerName: string }[];
  players: number;
}

export interface RecordDrawInput {
  prizeId: string; cartelaId: string; number: string; seed: string; commitHash: string; poolSize: number; revealOrder?: number[];
}

export interface CloseEventResult { status: ApiEvent['status']; won: number; consumed: number; }

export interface CreateEventInput {
  name: string;
  tier: ApiTier;
  scheduledAt?: string;
  closesAt?: string;
  liveUrl?: string;
}

export type UpdateEventInput = Partial<CreateEventInput> & { status?: ApiEvent['status'] };

/** Sorteios. A API já aplica o escopo: o anfitrião recebe só o sorteio dele. */
export const eventsApi = {
  list: (): Promise<ApiEvent[]> => get('/events'),
  get: (id: string): Promise<ApiEvent> => get(`/events/${id}`),
  create: (input: CreateEventInput): Promise<ApiEvent> => post('/events', input),
  update: (id: string, input: UpdateEventInput): Promise<ApiEvent> => patch(`/events/${id}`, input),
  remove: (id: string): Promise<void> => remove(`/events/${id}`),
  /** Resultados gravados no servidor. */
  draws: (id: string): Promise<ApiDraw[]> => get(`/events/${id}/draws`),
  /** Grava um prêmio sorteado (idempotente por prêmio). */
  recordDraw: (id: string, input: RecordDrawInput): Promise<ApiDraw> => post(`/events/${id}/draws`, input),
  /** Quem entra no bolão (regra de ciclos). */
  pool: (id: string): Promise<EventPool> => get(`/events/${id}/pool`),
  /** Contagem leve do bolão agora (tempo real no início). */
  poolSummary: (id: string): Promise<{ cartelas: number; players: number; at: string }> => get(`/events/${id}/pool/summary`),
  /** Encerra a live: marca ganhadores e consome o ciclo (semanal → "já jogou"; mensal → tudo zera). */
  close: (id: string, wonCartelaIds: string[]): Promise<CloseEventResult> => post(`/events/${id}/close`, { wonCartelaIds }),
};
